module.exports = __webpack_public_path__ + "static/media/football.d26541c3.png";